// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

const BASE_ROUTE = 'investors-companies-root'

export const ROUTE_NAMES = {
  CREATE: 'investors-companies-create',
  LIST: 'investors-companies-list',
  DETAILS: 'investors-companies-details',
  EDIT: 'investors-companies-edit',
  BANK_ACCOUNT_EDIT: 'bank-account-edit',
  ACCOUNT_EDIT: 'account-edit',
  TRANSFERS: 'investors-companies-transfers'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'investors-companies'
  },
  [ROUTE_NAMES.CREATE]: {
    name: ROUTE_NAMES.CREATE,
    path: 'create'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: ':id'
  },
  [ROUTE_NAMES.EDIT]: {
    name: ROUTE_NAMES.EDIT,
    path: ':id/edit'
  },
  [ROUTE_NAMES.ACCOUNT_EDIT]: {
    name: ROUTE_NAMES.ACCOUNT_EDIT,
    path: ':id/account/:a_id'
  },
  [ROUTE_NAMES.BANK_ACCOUNT_EDIT]: {
    name: ROUTE_NAMES.BANK_ACCOUNT_EDIT,
    path: ':id/bank-account/:ba_id'
  },
  [ROUTE_NAMES.TRANSFERS]: {
    name: ROUTE_NAMES.TRANSFERS,
    path: ':id/transfers/:a_id'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view/>',
      name: 'InvestorsAccountsModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.CREATE].name,
        path: ROUTES[ROUTE_NAMES.CREATE].path,
        component: (resolve) => require(['./views/create'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS].name,
        path: ROUTES[ROUTE_NAMES.DETAILS].path,
        component: (resolve) => require(['./views/details'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.EDIT].name,
        path: ROUTES[ROUTE_NAMES.EDIT].path,
        component: (resolve) => require(['./views/edit'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.ACCOUNT_EDIT].name,
        path: ROUTES[ROUTE_NAMES.ACCOUNT_EDIT].path,
        component: (resolve) => require(['./views/account-edit'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.BANK_ACCOUNT_EDIT].name,
        path: ROUTES[ROUTE_NAMES.BANK_ACCOUNT_EDIT].path,
        component: (resolve) => require(['./views/bank-account-edit'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.TRANSFERS].name,
        path: ROUTES[ROUTE_NAMES.TRANSFERS].path,
        component: (resolve) => require(['./views/transfers'], resolve),
        props: true
      }
    ]
  }
]
